// // banner text
       document.addEventListener('DOMContentLoaded', function () {
  // Get the rotating text container
  const rotatingTextContainer = document.querySelector('.rotating-text');

  // Get the sentence from the data attribute
  const sentence = rotatingTextContainer.getAttribute('data-text');

  // Split the sentence into letters and wrap each letter in a span
  rotatingTextContainer.innerHTML = sentence
    .split('')
    .map(letter => `<span>${letter === ' ' ? '&nbsp;' : letter}</span>`)
    .join('');

  // Select all the newly created spans
  const letters = rotatingTextContainer.querySelectorAll('span');

  // Animate each letter
  letters.forEach((letter, index) => {
    setTimeout(() => {
      letter.classList.add('visible');
    }, index * 150); // Adjust timing for each letter
  });
});

// hover video
// document.addEventListener("DOMContentLoaded", () => {
//   const categories = document.querySelectorAll(".gbc");

//   categories.forEach((category) => {
//     const video = category.querySelector("video");

//     category.addEventListener("mouseenter", () => {
//       video.play(); // Start playing the video
//     });

//     category.addEventListener("mouseleave", () => {
//       video.pause(); // Pause the video
//       video.currentTime = 0; // Reset the video to the first frame
//     });
//   });
// });

document.addEventListener("DOMContentLoaded", () => {
  const categories = document.querySelectorAll(".gbc");

  categories.forEach((category) => {
    const video = category.querySelector("video");

    category.addEventListener("mouseenter", () => {
      video.pause(); // Pause the video
      video.currentTime = 0; // Reset the video to the first frame
    });

    category.addEventListener("mouseleave", () => {
      // video.pause(); // Pause the video
      // video.currentTime = 0; // Reset the video to the first frame
      video.play(); // Start playing the video
    });
  });
});

// increment
// Select elements
    // const quantityInput = document.querySelector('.quentity input');
    // const incrementButton = document.querySelector('.quentity .increment');
    // const decrementButton = document.querySelector('.quentity .decrement');

    // // Increment value
    // incrementButton.addEventListener('click', () => {
    //   let currentValue = parseInt(quantityInput.value);
    //   quantityInput.value = currentValue + 1;
    // });

    // // Decrement value
    // decrementButton.addEventListener('click', () => {
    //   let currentValue = parseInt(quantityInput.value);
    //   if (currentValue > 1) { // Ensure it doesn't go below 1
    //     quantityInput.value = currentValue - 1;
    //   }
    // });

    // // Prevent invalid values
    // quantityInput.addEventListener('input', () => {
    //   if (quantityInput.value === '' || parseInt(quantityInput.value) < 1) {
    //     quantityInput.value = 1;
    //   }
    // });
// document.addEventListener("DOMContentLoaded", () => {
//   const decrement = document.querySelector(".decrement");
//   const increment = document.querySelector(".increment");
//   const quantityInput = document.querySelector("#quantity");

//   increment.addEventListener("click", () => {
//     quantityInput.value = parseInt(quantityInput.value) + 1;
//   });

//   decrement.addEventListener("click", () => {
//     if (parseInt(quantityInput.value) > 1) {
//       quantityInput.value = parseInt(quantityInput.value) - 1;
//     }
//   });
// });
document.addEventListener("DOMContentLoaded", () => {
  const quantityInput = document.getElementById("quantity");
  const incrementBtn = document.querySelector(".increment");
  const decrementBtn = document.querySelector(".decrement");

  // Increment quantity
  incrementBtn.addEventListener("click", () => {
    quantityInput.value = parseInt(quantityInput.value) + 1;
  });

  // Decrement quantity
  decrementBtn.addEventListener("click", () => {
    if (parseInt(quantityInput.value) > 1) {
      quantityInput.value = parseInt(quantityInput.value) - 1;
    }
  });
});


// // thubnail
//   document.addEventListener("DOMContentLoaded", function () {
//     const thumbnails = document.querySelectorAll(".thumbnail");
//     const mainImage = document.getElementById("mainImage");
//     const mainVideo = document.getElementById("mainVideo");

//     thumbnails.forEach(thumbnail => {
//       thumbnail.addEventListener("click", function () {
//         let fullSrc = this.getAttribute("data-full");

//         // Check if it's an image or a video
//         if (this.tagName === "IMG") {
//           mainImage.src = fullSrc;
//           mainImage.style.display = "inline-block";
//           if (mainVideo) mainVideo.style.display = "none";
//         } else if (this.tagName === "VIDEO") {
//           mainVideo.src = fullSrc;
//           mainVideo.style.display = "block";
//           if (mainImage) mainImage.style.display = "none";
//         }

//         // Highlight selected thumbnail
//         thumbnails.forEach(t => t.classList.remove("active"));
//         this.classList.add("active");
//       });
//     });
//   });




  document.addEventListener("DOMContentLoaded", function () {
    const thumbnails = document.querySelectorAll(".thumbnail");
    const mainImage = document.getElementById("mainImage");
    const mainVideo = document.getElementById("mainVideo");
    const prevBtn = document.getElementById("prevBtn");
    const nextBtn = document.getElementById("nextBtn");

    let currentIndex = 0;

    function updateMainDisplay(index) {
      const selected = thumbnails[index];
      const fullSrc = selected.getAttribute("data-full");

      if (selected.tagName === "IMG") {
        mainImage.src = fullSrc;
        mainImage.style.display = "inline-block";
        if (mainVideo) mainVideo.style.display = "none";
      } else if (selected.tagName === "VIDEO") {
        const source = mainVideo.querySelector("source");
        source.src = fullSrc;
        mainVideo.load();
        mainVideo.style.display = "block";
        if (mainImage) mainImage.style.display = "none";
      }

      // Active class
      thumbnails.forEach(t => t.classList.remove("active"));
      selected.classList.add("active");
    }

    thumbnails.forEach((thumb, i) => {
      thumb.addEventListener("click", function () {
        currentIndex = i;
        updateMainDisplay(currentIndex);
      });
    });

    prevBtn.addEventListener("click", function () {
      currentIndex = (currentIndex - 1 + thumbnails.length) % thumbnails.length;
      updateMainDisplay(currentIndex);
    });

    nextBtn.addEventListener("click", function () {
      currentIndex = (currentIndex + 1) % thumbnails.length;
      updateMainDisplay(currentIndex);
    });

    // Optional: Initialize with first media
    updateMainDisplay(currentIndex);
  });



  // subscription
  const form = document.getElementById('subscribe-form');
  const emailInput = document.getElementById('subscribe-email');
  const msg = document.getElementById('subscribe-msg');

  form.addEventListener('submit', function(e) {
    e.preventDefault();

    const email = emailInput.value.trim();
    if (!email) {
      msg.textContent = 'Please enter a valid email.';
      msg.style.color = 'red';
      msg.style.display = 'block';
      return;
    }

    // Use Shopify AJAX API to submit email
    fetch('/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        'form_type': 'customer',
        'utf8': '✓',
        'contact[email]': email
      })
    })
    .then(response => {
      if (response.ok) {
        msg.textContent = `Thank you for subscribing with ${email}!`;
        msg.style.color = 'green';
        msg.style.display = 'block';
        emailInput.value = '';
      } else {
        msg.textContent = 'Subscription failed. Please try again.';
        msg.style.color = 'red';
        msg.style.display = 'block';
      }
    })
    .catch(() => {
      msg.textContent = 'Subscription failed. Please try again.';
      msg.style.color = 'red';
      msg.style.display = 'block';
    });
  });




// page load
// location.reload(true); // Deprecated, but still works in some browsers


